import React from "react";
import logo from "../assets/img/YOD Business Solutions Logo-Red.png";

const AboutHero = () => {
  return (
    <>
      {/* Hero Header */}
      <div className="container-fluid text-center" style={{ backgroundColor: "transparent" }}>
        <div className="container py-5" style={{ maxWidth: "900px" }}>
          <h3
            className="display-3 mb-4"
            data-aos="fade-down"
            data-aos-delay="100"
            style={{ color: "#A71717" }}
          >
            About Us
          </h3>
        </div>
      </div>

      {/* About Content */}
      <div className="container-fluid py-5">
        <div className="container py-5">
          <div className="row g-5">
            {/* Left Side - Logo + Stats */}
            <div className="col-xl-5" data-aos="fade-right" data-aos-delay="100">
              <div className="bg-light rounded">
                <img src={logo} alt="YOD Business Solutions" className="img-fluid w-100" />
              </div>
              <div className="mt-4 text-center">
                <div className="row g-4">
                  <div className="col-6">
                    <div className="counter-item">
                      <h1 className="text-secondary">2+</h1>
                      <p className="mb-0">Years Experience</p>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="counter-item">
                      <h1 className="text-secondary">100+</h1>
                      <p className="mb-0">Projects Completed</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Side - Content */}
            <div className="col-xl-7" data-aos="fade-left" data-aos-delay="300">
              <h5 className="text-uppercase" style={{ color: "#FFAA00" }}>
                About YOD Business Solutions
              </h5>
              <h1 className="display-5 mb-4" style={{ color: "#A71717" }}>
                We Transform Ethiopian Businesses Through Technology
              </h1>
              <p className="mb-4" style={{ color: "#666" }}>
                We are a transparent team with 5 years of experience customizing workflows and improving productivity
                using cutting-edge ICT solutions and software development. Our expertise in the African market makes us
                uniquely positioned to serve businesses across the continent.
              </p>

              {/* Our Story */}
              <div className="mb-4">
                <h5 style={{ color: "#A71717" }}>Our Story</h5>
                <p style={{ color: "#666" }}>
                  Founded in 2018, YOD Business Solutions emerged from a vision to revolutionize how African businesses
                  operate. What started as a commitment to provide innovative solutions has grown into a comprehensive
                  suite of services trusted by leading organizations across multiple industries. Our journey is marked
                  by continuous innovation, unwavering dedication to excellence, and a deep understanding of local market
                  needs.
                </p>
              </div>

              {/* Key Features */}
              <div className="row gy-4 align-items-center">
                <div className="col-12 col-sm-6 d-flex align-items-center">
                  <i className="fas fa-check-circle fa-3x" style={{ color: "#A71717" }}></i>
                  <h5 className="ms-4 mb-0">Industry Expertise</h5>
                </div>
                <div className="col-12 col-sm-6 d-flex align-items-center">
                  <i className="fas fa-shield-alt fa-3x" style={{ color: "#A71717" }}></i>
                  <h5 className="ms-4 mb-0">Secure Solutions</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutHero;
